module.exports = __webpack_public_path__ + "static/media/isle-card.91ae2d46.png";